import { useMemo } from "react";
import { Link } from "react-router-dom";
import { HStack, Skeleton, Stack, Text } from "@chakra-ui/react";

import { RoutesMap } from "../../../../../routes.tsx";
import { useGetCardsQuery } from "../../../../../api/cards";
import { PaymentBlockCardDetails } from "./PaymentBlockCardDetails.tsx";
import { getMainPaymentMethod, getPaymentMethodName } from "../../../../../utils";

export function PaymentBlockCard() {
  const { data, isPending, isError } = useGetCardsQuery();

  const name = useMemo(() => {
    const mainCard = getMainPaymentMethod(data);
    return getPaymentMethodName(mainCard);
  }, [data]);

  if (isPending) {
    return (
      <Stack h="43px" spacing={1}>
        <Skeleton w="80px" h="14px" />
        <Skeleton h="25px" />
      </Stack>
    );
  }

  return (
    <Stack h="43px" spacing={1}>
      <Text fontSize="xs" lineHeight="14px">Будет списано</Text>

      <HStack justifyContent="space-between">
        <PaymentBlockCardDetails name={name} isError={isError} />

        {name && (
          <Link to={RoutesMap.cards.index}>
            <Text variant="brand">Изменить</Text>
          </Link>
        )}
      </HStack>
    </Stack>
  );
}
